import keyMirror from 'keymirror';

import type { TFunction } from 'i18next';

export const errorHandlerActionTypes = keyMirror({
	HANDLE_ERROR: null,
	CLEAR_ERROR: null,
});

export const getErrorInfoDependsOfStatusCode = (
	statusCode: number | string,
	param: 'title' | 'description' | 'back_to_home',
	t?: TFunction,
): string => {
	let errorMessage = '';

	if (statusCode === 404) {
		errorMessage = `404.${param}`;
	} else if (statusCode === 403) {
		errorMessage = `403.${param}`;
	} else {
		errorMessage = `500.${param}`;
	}

	return t ? t(errorMessage) : errorMessage;
};
